import "./index.css";
import "./lib/legacy-zod-messages";

import { createRoot } from "react-dom/client";

import App from "./App.tsx";

createRoot(document.getElementById("root")!).render(<App />);
